import { MISSION_BALANCESHEET_TOTAL } from "constants/constants";
import "./SectionSum.scss";

const SectionSum = ({ label, value }) => (
  <div className="parent-section-sum">
    <div className="section-sum">
      <p>{label}</p>
      <p> {value}/{MISSION_BALANCESHEET_TOTAL}</p>
    </div>
  </div>
);

export default SectionSum;
